import { css } from 'styled-components';
import { hexToRGB } from './colorConverter';
import { COLORS } from '../constants/colors';
var ShadowType;
(function (ShadowType) {
    ShadowType["LOW"] = "low";
    ShadowType["MEDIUM"] = "medium";
    ShadowType["HIGH"] = "high";
})(ShadowType || (ShadowType = {}));
export const shadowElevation = css `
  ${({ $shadowElevation }) => `
    ${$shadowElevation ? shadowElevationVariant[$shadowElevation] : ''}
  `}
`;
export const filterShadowElevation = css `
  ${({ $shadowElevation }) => `
    ${$shadowElevation ? filterShadowElevationVariant[$shadowElevation] : ''}
  `}
`;
const shadowElevationVariant = {
    [ShadowType.LOW]: `
  box-shadow: 0px 0px 12px ${hexToRGB(COLORS.BLACK[900], 0.1)},
    0px 4px 8px ${hexToRGB(COLORS.BLACK[900], 0.04)};
`,
    [ShadowType.MEDIUM]: `
  box-shadow: 0px 4px 24px ${hexToRGB(COLORS.BLACK[900], 0.1)},
    0px 4px 16px ${hexToRGB(COLORS.BLACK[900], 0.04)};
`,
    [ShadowType.HIGH]: `
  box-shadow: 0px 0px 48px ${hexToRGB(COLORS.BLACK[900], 0.1)},
    0px 8px 24px ${hexToRGB(COLORS.BLACK[900], 0.04)};
`,
};
const filterShadowElevationVariant = {
    [ShadowType.LOW]: `
  filter: drop-shadow(0px 4px 12px ${hexToRGB(COLORS.BLACK[900], 0.1)})
    drop-shadow(0px 4px 8px ${hexToRGB(COLORS.BLACK[900], 0.04)});
`,
    [ShadowType.MEDIUM]: `
  filter: drop-shadow(0px 4px 24px ${hexToRGB(COLORS.BLACK[900], 0.1)})
    drop-shadow(0px 4px 16px ${hexToRGB(COLORS.BLACK[900], 0.04)});
`,
    [ShadowType.HIGH]: `
  filter: drop-shadow(0px 0px 48px ${hexToRGB(COLORS.BLACK[900], 0.1)})
    drop-shadow(0px 8px 24px ${hexToRGB(COLORS.BLACK[900], 0.04)});
`,
};
export const shadowElevationVariantStyles = {
    [ShadowType.LOW]: css `
    ${shadowElevationVariant[ShadowType.LOW]}
  `,
    [ShadowType.MEDIUM]: css `
    ${shadowElevationVariant[ShadowType.MEDIUM]}
  `,
    [ShadowType.HIGH]: css `
    ${shadowElevationVariant[ShadowType.HIGH]}
  `,
};
export const shadowElevationKeys = ['shadowElevation'];
